import type { FormFieldsType } from '../types';

export function makeIndexedName(
  name: string,
  position: number | string
): keyof FormFieldsType {
  return `${name}-${position}` as keyof FormFieldsType;
}
